/* import __COLOCATED_TEMPLATE__ from './non-contracted-under-limit.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { type TooltipRow } from 'embercom/components/billing/usage/tooltips-new/shared-components/tooltip-item';
import type { TooltipComponentSignature } from '../schemas';

export default class NonContractedUnderLimitComponent extends Component<TooltipComponentSignature> {
  @service declare intl: IntlService;
  @service declare customerService: $TSFixMe;

  get inTrial() {
    return this.customerService.customer?.inTrial;
  }

  get noAdditionalUsage() {
    let res = [
      {
        label: this.intl.t('billing.summary.usage-tooltip.no_additional_usage'),
        muted: true,
        noPadding: true,
      },
    ];
    return res as TooltipRow[];
  }

  get trialDisclaimer() {
    return [
      {
        label: this.intl.t('billing.summary.usage-tooltip.trial_disclaimer'),
        muted: true,
        noPadding: true,
      },
    ] as TooltipRow[];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::Usage::TooltipsNew::TieredMetrics::NonContractedUnderLimit': typeof NonContractedUnderLimitComponent;
  }
}
